export default __webpack_public_path__ + "static/media/share_story.af5596a1.png";